import { render } from "./MyPasses.vue?vue&type=template&id=2d1db107"
import script from "./MyPasses.vue?vue&type=script&lang=js"
export * from "./MyPasses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__